import React from 'react';
import classNames from 'classnames';

import { Radio } from './Radio';

import styles from './RadioOption.module.scss';

/** A stack of `RadioOption`s answering one question. */
export function RadioOptionGroup({ className, children, ...props }) {
  return (
    <div
      className={classNames(styles.group, className)}
      role="radiogroup"
      {...props}
    >
      {children}
    </div>
  );
}

/**
 * One choice: a radio with a title and a muted line explaining it. Children
 * go under the choice, for detail that only matters once it's picked (a name
 * to enter, say).
 */
export function RadioOption({
  title,
  description,
  disabled = false,
  children,
  ...radioProps
}) {
  return (
    <div className={classNames({ [styles.disabled]: disabled })}>
      <Radio disabled={disabled} {...radioProps}>
        <span className={styles.copy}>
          <span className={styles.title}>{title}</span>
          {description && (
            <span className={styles.description}>{description}</span>
          )}
        </span>
      </Radio>
      {children && <div className={styles.detail}>{children}</div>}
    </div>
  );
}

export default RadioOption;
